import React, { useEffect } from "react";

import { StorageKeys } from '@utils/LocalStorage';

import Cal, { getCalApi } from "@calcom/embed-react";

interface IProps {
    url: string;
}

const CalComponent = (props: IProps) => {
    const { url } = props;

    const parsedUrl = new URL(url);
    const endpoint = parsedUrl.pathname;
    const endpointWithoutSlash = endpoint.substring(1);

    const userEmail = localStorage.getItem(StorageKeys.EMAIL);

    useEffect(() => {
        (async function () {
            const cal = await getCalApi();
            cal("ui", { "styles": { "branding": { "brandColor": "#C02026" } }, "hideEventTypeDetails": false, "layout": "month_view" });
        })();
    }, [])

    return <Cal
        calLink={endpointWithoutSlash}
        style={{ width: "100%", height: "100%", overflow: "scroll", marginTop: "2rem" }}
        config={{
            name: localStorage.getItem(StorageKeys.USER_NAME),
            email: userEmail,
            layout: 'month_view',
        }}
    />;
};

export default CalComponent;
